export default (id) => ({
    open: false,
    uploadedFiles: [], //Usado para la vista

    get files() {
        return this.uploadedFiles.map(file => file[1]);
    },

    init(){
        this.$refs.dropzone.addEventListener('dragover', (e) => {
            e.preventDefault();
            dropzone.classList.add('border-blue-500');
        });

        this.$refs.dropzone.addEventListener('dragleave', () => {
            dropzone.classList.remove('border-blue-500');
        });

        this.$refs.dropzone.addEventListener('drop', (e) => {
            e.preventDefault();
            dropzone.classList.remove('border-blue-500');

            const files = e.dataTransfer.files;
            this.handleFiles(files);
        });

        this.$refs.fileInput.addEventListener('change', (e) => {
            const files = e.target.files;
            this.handleFiles(files);
        });
    },

    handleFiles(files) {
        for (const file of files) {
            this.uploadedFiles.push([
                `${file.name} (${this.formatBytes(file.size)})`,
                file,
            ]);
        }
        this.dispatchFiles();
    },

    quitFile(index) {
        this.uploadedFiles.splice(index, 1);
        this.dispatchFiles();

    },

    cleanAll() {
        this.uploadedFiles = [];
        this.$refs.fileInput.value = '';
        this.dispatchFiles();
    },

    dispatchFiles() {
        this.$dispatch(`file-uploader--${id}:upload`, this.uploadedFiles);
        this.uploadedFiles = [];
    },

    formatBytes(bytes) {
        if (bytes === 0) return '0 Bytes';

        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    }
})
